{{ env.name }} status is UP
